import React, { useState } from 'react'
import ReactDraggable from 'react-draggable'

const canvasSize = { width: "800", height: "600" }

function DraggableItem({ id, selected, onSelect, children }) {
    const [isDragging, setIsDragging] = useState(false);
    const isSelected = selected && selected.indexOf(id) >= 0;

    function handleClick(e, idx) {
        onSelect(idx);
    }

    return (
        <ReactDraggable
            onStart={() => setIsDragging(true)}
            onStop={(e) => { console.log(e); setIsDragging(false); }}
            disabled={!isSelected}
        >
            <g>
                <g className={`item ${isSelected ? "selected" : ""} ${isDragging ? "dragging" : ""}`} onClick={e => handleClick(e, id)}>
                    {children}
                </g>
            </g>
        </ReactDraggable>
    )
}

function DraggableElements(props) {
    const { children, ...restProps } = props;
    const draggable = children.map((child, idx) => <DraggableItem key={idx} id={idx} {...restProps}>{child}</DraggableItem>);
    return (
        <>{draggable}</>
    )
}

export default function CanvasMap(props) {
    const [selected, setSelected] = React.useState([]);
    function select(idx) {
        const newSelection = selected.indexOf(idx) >= 0 ? selected.filter(item => item != idx) : [...selected, idx];
        setSelected(newSelection);
    }

    return (
        <svg className="canvas" {...canvasSize} xmlns="http://www.w3.org/2000/svg"  >
            <DraggableElements selected={selected} onSelect={select}>
                <rect x="120" y="250" width="100" height="100" fill="lightgrey" />
                <circle cx="400" cy="100" r="75" fill="lightblue" />
                <circle cx="400" cy="100" r="75" fill="lightblue" />
            </DraggableElements>
        </svg>
    );
}
 


// https://codepen.io/doorwarpranjal/pen/jOwPBLB?editors=1111